import { Home, List, Settings } from "lucide-react";
import { Button } from "@web/components/ui/button";
import type { ReaderPreference } from "../../../api";
import type { ReaderPanel } from "../../../reader/types";
import { ThemeToggleButton } from "../theme-toggle-button";

interface ReaderToolbarProps {
  activePanel: ReaderPanel;
  theme: ReaderPreference["theme"];
  title?: string;
  visible: boolean;
  onPanelChange: (panel: ReaderPanel) => void;
  onThemeToggle: () => void;
  onReturn: () => void;
}

export function MobileReaderToolbar({ activePanel, theme, title, visible, onPanelChange, onThemeToggle, onReturn }: ReaderToolbarProps) {
  return (
    <div
      className={`reader-safe-toolbar fixed inset-x-0 top-0 z-30 border-b bg-background/95 px-2 py-2 backdrop-blur transition duration-200 ease-out supports-[backdrop-filter]:bg-background/60 ${
        visible ? "translate-y-0 opacity-100" : "pointer-events-none -translate-y-full opacity-0"
      }`}
    >
      <div className="grid grid-cols-[auto_minmax(0,1fr)_auto] items-center gap-1">
        <div className="flex items-center gap-1">
          <Button size="sm" variant={activePanel === "catalog" ? "secondary" : "outline"} onClick={() => onPanelChange(activePanel === "catalog" ? null : "catalog")}>
            <List className="size-4" />
            目录
          </Button>
          <Button size="sm" variant={activePanel === "settings" ? "secondary" : "outline"} onClick={() => onPanelChange(activePanel === "settings" ? null : "settings")}>
            <Settings className="size-4" />
            设置
          </Button>
        </div>
        <p className="truncate px-2 text-center text-sm font-medium text-foreground/85">{title}</p>
        <div className="flex items-center gap-1">
          <Button size="sm" variant="outline" onClick={onReturn}>
            <Home className="size-4" />
            书架
          </Button>
          <ThemeToggleButton theme={theme} variant="outline" onToggle={onThemeToggle} />
        </div>
      </div>
    </div>
  );
}

export function ReaderToolbar({ activePanel, theme, title, visible, onPanelChange, onThemeToggle, onReturn }: ReaderToolbarProps) {
  return (
    <div
      className={`reader-safe-toolbar fixed inset-x-0 top-0 z-30 border-b bg-background/95 backdrop-blur transition duration-200 ease-out supports-[backdrop-filter]:bg-background/60 ${
        visible ? "translate-y-0 opacity-100" : "pointer-events-none -translate-y-full opacity-0"
      }`}
    >
      <div className="grid h-14 w-full grid-cols-[auto_minmax(0,1fr)_auto] items-center gap-3 px-4">
        <div className="flex items-center gap-1">
          <Button size="sm" variant={activePanel === "catalog" ? "secondary" : "ghost"} onClick={() => onPanelChange(activePanel === "catalog" ? null : "catalog")}>
            <List className="size-4" />
            目录
          </Button>
          <Button size="sm" variant={activePanel === "settings" ? "secondary" : "ghost"} onClick={() => onPanelChange(activePanel === "settings" ? null : "settings")}>
            <Settings className="size-4" />
            设置
          </Button>
        </div>
        <p className="truncate px-4 text-center text-sm font-medium tracking-wide text-foreground/85">{title}</p>
        <div className="flex items-center gap-1">
          <Button size="sm" variant="ghost" onClick={onReturn}>
            <Home className="size-4" />
            书架
          </Button>
          <ThemeToggleButton theme={theme} onToggle={onThemeToggle} />
        </div>
      </div>
    </div>
  );
}
